import { ReactNode } from 'react'
import {
  Container,
  Percentage,
  Title,
  Total,
  Wrapper,
} from './DashboardInfo.style'

export type DashboardInfoProps = {
  children: ReactNode
  total: number | undefined | string
  percentage?: number
  color: string
  colorTitle: string
}

export function DashboardInfo({
  children,
  total,
  percentage,
  color,
  colorTitle,
}: DashboardInfoProps) {
  return (
    <Container>
      <Title colorTitle={colorTitle}>{children}</Title>
      <Wrapper>
        <Total color={color}>{total?.toLocaleString('pt-BR')}</Total>
        {percentage && (
          <Percentage isPlus={percentage > 0}>
            {percentage > 0 && '+'}
            {percentage}%
          </Percentage>
        )}
      </Wrapper>
    </Container>
  )
}
